/**
 * data-testid catalog (per data-testid usage rules).
 * Keep stable across renames.
 */
export const TID = {
  // Public
  signupForm: "signup-form",
  signupEmail: "signup-email",
  signupPassword: "signup-password",
  signupRoleClient: "signup-role-client",
  signupRoleContractor: "signup-role-contractor",
  signupSubmit: "signup-submit",
  signinForm: "signin-form",
  signinEmail: "signin-email",
  signinPassword: "signin-password",
  signinMfa: "signin-mfa-code",
  signinSubmit: "signin-submit",
  forgotEmail: "forgot-email",
  forgotSubmit: "forgot-submit",
  resetPassword: "reset-password",
  resetSubmit: "reset-submit",
  verifyBanner: "verify-banner",
  verifyAction: "verify-action",

  // Account
  profileForm: "profile-form",
  profileDisplayName: "profile-display-name",
  profileSave: "profile-save",
  passwordCurrent: "password-current",
  passwordNew: "password-new",
  passwordSubmit: "password-submit",
  mfaSetupBtn: "mfa-setup-btn",
  mfaCodeInput: "mfa-code-input",
  mfaEnableBtn: "mfa-enable-btn",
  mfaDisableBtn: "mfa-disable-btn",
  sessionRow: "session-row",
  logoutAll: "logout-all",

  // Onboarding
  orgName: "onboarding-org-name",
  orgCurrency: "onboarding-org-currency",
  orgSubmit: "onboarding-org-submit",

  // Admin
  adminDash: "admin-dashboard",
  adminUsersTable: "admin-users-table",
  adminUserRow: "admin-user-row",
  adminSuspend: "admin-suspend-btn",
  adminRestore: "admin-restore-btn",
  adminGrantRole: "admin-grant-role",
  adminFeesClient: "admin-fees-client",
  adminFeesContractor: "admin-fees-contractor",
  adminFeesSave: "admin-fees-save",
  adminConfigRow: "admin-config-row",
  adminAuditTable: "admin-audit-table",

  // Nav
  navHome: "nav-home",
  navAccount: "nav-account",
  navSecurity: "nav-security",
  navAdmin: "nav-admin",
  navLogout: "nav-logout",
  navProfile: "nav-contractor-profile",

  // CP-3.2 contractor profile
  cpRoot: "contractor-profile-root",
  cpCompleteness: "contractor-completeness-meter",
  cpStepBasics: "cp-step-basics",
  cpStepCrew: "cp-step-crew",
  cpStepRate: "cp-step-rate",
  cpStepRegions: "cp-step-regions",
  cpStepSkills: "cp-step-skills",
  cpStepCerts: "cp-step-certs",
  cpStepLangs: "cp-step-langs",
  cpStepTravel: "cp-step-travel",
  cpStepInsurance: "cp-step-insurance",
  cpStepMedia: "cp-step-media",
  cpStepVisibility: "cp-step-visibility",
  cpCompanyName: "cp-company-name",
  cpWebsite: "cp-website",
  cpShortBio: "cp-short-bio",
  cpLongBio: "cp-long-bio",
  cpYears: "cp-years-experience",
  cpPublicEmail: "cp-public-email",
  cpPublicPhone: "cp-public-phone",
  cpRate: "cp-hourly-rate",
  cpCurrency: "cp-currency",
  cpCrewKind: "cp-crew-kind",
  cpMaxHelpers: "cp-max-helpers",
  cpAcceptLead: "cp-accept-lead",
  cpAcceptHelper: "cp-accept-helper",
  cpVisibilitySelect: "cp-visibility-select",
  cpTravelRadius: "cp-travel-radius",
  cpWillingTravel: "cp-willing-travel",
  cpWillingFly: "cp-willing-fly",
  cpWillingOvernight: "cp-willing-overnight",
  cpInsuranceProvider: "cp-insurance-provider",
  cpInsurancePolicy: "cp-insurance-policy",
  cpInsuranceCoverage: "cp-insurance-coverage",
  cpInsuranceCurrency: "cp-insurance-currency",
  cpPhotoUpload: "cp-photo-upload",
  cpLogoUpload: "cp-logo-upload",
  cpPhotoPreview: "cp-photo-preview",
  cpLogoPreview: "cp-logo-preview",
  cpSaveBasics: "cp-save-basics",
  cpSaveCrew: "cp-save-crew",
  cpSaveRate: "cp-save-rate",
  // CP-14.2b Workforce Offering
  cpStepOffering: "cp-step-offering",
  cpOfferingTable: "cp-offering-table",
  cpOfferingAddRow: "cp-offering-add-row",
  cpOfferingSave: "cp-offering-save",
  cpOfferingRow: "cp-offering-row",
  cpOfferingTitleSelect: "cp-offering-title-select",
  cpOfferingQty: "cp-offering-qty",
  cpOfferingRate: "cp-offering-rate",
  cpOfferingCurrency: "cp-offering-currency",
  cpOfferingSiteLead: "cp-offering-site-lead",
  cpOfferingNotes: "cp-offering-notes",
  cpOfferingRemove: "cp-offering-remove",
  // CP-14.3 Crew Shape Search
  cssRoot: "css-root",
  cssReqRow: "css-req-row",
  cssReqTitle: "css-req-title",
  cssReqQty: "css-req-qty",
  cssReqSiteLead: "css-req-site-lead",
  cssReqRemove: "css-req-remove",
  cssReqAdd: "css-req-add",
  cssTrack: "css-track",
  cssRegion: "css-region",
  cssVerifiedOnly: "css-verified-only",
  cssIncludeSolo: "css-include-solo",
  cssIncludeCompanies: "css-include-companies",
  cssKeyword: "css-keyword",
  cssSubmit: "css-submit",
  cssResultCard: "css-result-card",
  cssResultEvidence: "css-result-evidence",
  cssResultMatched: "css-result-matched",
  cssResultUnmatched: "css-result-unmatched",
  cssResultsEmpty: "css-results-empty",
  // CP-15.4 Admin Marketplaces tab
  adminMpTab: "admin-mp-tab",
  adminMpRegistry: "admin-mp-registry",
  adminMpRow: "admin-mp-row",
  adminMpDisplayName: "admin-mp-display-name",
  adminMpNavLabel: "admin-mp-nav-label",
  adminMpDescription: "admin-mp-description",
  adminMpOrder: "admin-mp-order",
  adminMpActive: "admin-mp-active",
  adminMpSave: "admin-mp-save",
  adminMpLabelsSection: "admin-mp-labels-section",
  adminMpLabelMpSelect: "admin-mp-label-mp-select",
  adminMpLabelRow: "admin-mp-label-row",
  adminMpLabelInput: "admin-mp-label-input",
  adminMpLabelVisible: "admin-mp-label-visible",
  adminMpLabelSave: "admin-mp-label-save",
  adminMpLabelDelete: "admin-mp-label-delete",
  adminMpPolicy: "admin-mp-policy",
  adminMpPolicyEditor: "admin-mp-policy-editor",
  adminMpPolicyError: "admin-mp-policy-error",
  adminMpPolicySave: "admin-mp-policy-save",
  adminMpListings: "admin-mp-listings",
  adminMpListingRow: "admin-mp-listing-row",
  adminMpListingStatus: "admin-mp-listing-status",
  adminMpListingSave: "admin-mp-listing-save",
  // CP-14.4 Admin title taxonomy
  adminTitlesTab: "admin-titles-tab",
  adminTitlesTable: "admin-titles-table",
  adminTitlesRow: "admin-titles-row",
  adminTitlesCode: "admin-titles-code",
  adminTitlesLabel: "admin-titles-label",
  adminTitlesAxis: "admin-titles-axis",
  adminTitlesOrder: "admin-titles-order",
  adminTitlesActive: "admin-titles-active",
  adminTitlesInUse: "admin-titles-in-use",
  adminTitlesSaveRow: "admin-titles-save-row",
  adminTitlesNewCode: "admin-titles-new-code",
  adminTitlesNewLabel: "admin-titles-new-label",
  adminTitlesNewAxis: "admin-titles-new-axis",
  adminTitlesNewOrder: "admin-titles-new-order",
  adminTitlesCreate: "admin-titles-create",
  cpSaveTravel: "cp-save-travel",
  cpSaveInsurance: "cp-save-insurance",
  cpLangSelect: "cp-lang-select",
  cpSkillsList: "cp-skills-list",
  cpRegionsList: "cp-regions-list",
  cpCertsList: "cp-certs-list",
  cpAddLang: "cp-add-lang",
  cpAddCert: "cp-add-cert",
  cpRemoveCert: "cp-remove-cert",
  cpSaveLangs: "cp-save-langs",
  cpSaveSkills: "cp-save-skills",
  cpSaveRegions: "cp-save-regions",
  cpVisibilityField: "cp-visibility-field",

  // CP-3.3 — Availability
  availRoot: "availability-root",
  availOpenAdd: "availability-open-add",
  availKind: "availability-kind",
  availDayPart: "availability-day-part",
  availStart: "availability-start",
  availEnd: "availability-end",
  availNote: "availability-note",
  availShare: "availability-share",
  availSave: "availability-save",
  availList: "availability-list",
  availBlock: "availability-block",
  availDelete: "availability-delete",
  availTz: "availability-timezone",
  availSaveTz: "availability-save-timezone",

  // CP-3.3 — Marketplace
  mpRoot: "marketplace-root",
  mpFilterRegion: "mp-filter-region",
  mpFilterSkill: "mp-filter-skill",
  mpFilterLang: "mp-filter-lang",
  mpFilterCompleteness: "mp-filter-completeness",
  mpFilterFrom: "mp-filter-from",
  mpFilterTo: "mp-filter-to",
  mpApply: "mp-apply-filters",
  mpResults: "mp-results",
  mpCard: "mp-card",
  mpCardVacation: "mp-card-vacation",
  mpScore: "mp-card-score",
  mpExplain: "mp-card-explain",
  mpOpenProfile: "mp-card-open-profile",

  // CP-3.3 — Public profile
  publicProfileRoot: "public-profile-root",

  // CP-4.1 — Jobs
  jobsRoot: "jobs-root",
  jobsList: "jobs-list",
  jobRow: "job-row",
  newJob: "new-job",
  jobTitle: "job-title",
  jobDescription: "job-description",
  jobTemplate: "job-template",
  jobRegion: "job-region",
  jobStartsAt: "job-starts-at",
  jobEndsAt: "job-ends-at",
  jobCurrency: "job-currency",
  jobHelperCount: "job-helper-count",
  jobAddress: "job-address",
  jobCity: "job-city",
  jobPostal: "job-postal",
  jobMeetLocation: "job-meet-location",
  jobMeetAt: "job-meet-at",
  jobParking: "job-parking",
  jobAccessNotes: "job-access-notes",
  jobNotesInternal: "job-notes-internal",
  jobSkills: "job-skills",
  jobLanguages: "job-languages",
  jobContactsList: "job-contacts-list",
  jobContactAdd: "job-contact-add",
  jobContactRemove: "job-contact-remove",
  jobSave: "job-save",
  jobPublish: "job-publish",
  jobCancel: "job-cancel",
  jobDetailRoot: "job-detail-root",
  jobDurationBadge: "job-duration-badge",
  jobStatusBadge: "job-status-badge",
  pkgUpload: "pkg-upload",
  pkgUploadKind: "pkg-upload-kind",
  pkgUploadTitle: "pkg-upload-title",
  pkgUploadNote: "pkg-upload-note",
  pkgUploadSubmit: "pkg-upload-submit",
  pkgList: "pkg-list",
  pkgRow: "pkg-row",
  pkgVersionRow: "pkg-version-row",
  pkgAddVersion: "pkg-add-version",

  // CP-4.2 — Bookings
  bookingsRoot: "bookings-root",
  bookingsList: "bookings-list",
  bookingRow: "booking-row",
  bookingState: "booking-state",
  bookingDetailRoot: "booking-detail-root",
  bookingAccept: "booking-accept",
  bookingDecline: "booking-decline",
  bookingAcceptMsg: "booking-accept-msg",
  bookingDeclineReason: "booking-decline-reason",
  bookingAddressBox: "booking-address-box",
  bookingContactsBox: "booking-contacts-box",
  bookOpenWizard: "book-open-wizard",
  bookWizardRoot: "book-wizard-root",
  bookWizardJob: "book-wizard-job",
  bookWizardHelperCount: "book-wizard-helper-count",
  bookWizardMessage: "book-wizard-message",
  bookWizardSubmit: "book-wizard-submit",
  bookWizardSummary: "book-wizard-summary",

  // Dashboard pills
  dashClientActiveJobs: "dash-client-active-jobs",
  dashLeadPending: "dash-lead-pending",

  // CP-5.3 — Crews & Helper Invitations + PO
  crewRoot: "crew-root",
  crewCounters: "crew-counters",
  crewStatusPill: "crew-status-pill",
  crewSlotsTotal: "crew-slots-total",
  crewSlotsFilled: "crew-slots-filled",
  crewSlotsPending: "crew-slots-pending",
  crewInvitationsTable: "crew-invitations-table",
  crewInvitationRow: "crew-invitation-row",
  crewInviteOpen: "crew-invite-open",
  crewInviteHelperUuid: "crew-invite-helper-uuid",
  crewInviteRate: "crew-invite-rate",
  crewInviteMessage: "crew-invite-message",
  crewInviteSubmit: "crew-invite-submit",
  crewInviteWithdraw: "crew-invite-withdraw",
  crewStartWork: "crew-start-work",
  crewSkillCoverage: "crew-skill-coverage",
  crewSkillCovered: "crew-skill-covered",
  crewSkillUncovered: "crew-skill-uncovered",
  helperInboxRoot: "helper-inbox-root",
  helperInboxRow: "helper-inbox-row",
  helperInvitationDetail: "helper-invitation-detail",
  helperInvitationAccept: "helper-invitation-accept",
  helperInvitationDecline: "helper-invitation-decline",
  helperInvitationWithdraw: "helper-invitation-withdraw",
  helperInvitationAddressBox: "helper-invitation-address-box",
  clientCrewCard: "client-crew-card",
  clientCrewRoster: "client-crew-roster",
  clientCrewRosterRow: "client-crew-roster-row",
  bookingPoField: "booking-po-field",
  bookingPoBadge: "booking-po-badge",
  bookingPoEdit: "booking-po-edit",
  bookingPoInput: "booking-po-input",
  bookingPoSave: "booking-po-save",
  adminCrewsTable: "admin-crews-table",
  adminCrewsRow: "admin-crews-row",
  adminInvitationsTable: "admin-invitations-table",
  adminInvitationsRow: "admin-invitations-row",

  // CP-6.3 — Phase 6 (Timesheets, Ratings, Completion, Trust)
  // Lead Timesheets tab
  leadTimesheetsTab: "lead-timesheets-tab",
  leadTimesheetSubmit: "lead-timesheet-submit",
  leadTimesheetHours: "lead-timesheet-hours",
  leadTimesheetOutcome: "lead-timesheet-outcome",
  leadTimesheetStart: "lead-timesheet-start",
  leadTimesheetEnd: "lead-timesheet-end",
  leadTimesheetNotes: "lead-timesheet-notes",
  leadTimesheetRow: "lead-timesheet-row",
  leadTimesheetApprove: "lead-timesheet-approve",
  leadTimesheetReject: "lead-timesheet-reject",
  leadRatingsPanel: "lead-ratings-panel",
  leadRateHelperBtn: "lead-rate-helper-btn",
  leadRateHelperScore: "lead-rate-helper-score",
  leadRateHelperComment: "lead-rate-helper-comment",
  leadRateHelperSubmit: "lead-rate-helper-submit",
  // Helper log hours + rate lead
  helperLogHoursForm: "helper-log-hours-form",
  helperLogOutcome: "helper-log-outcome",
  helperLogHours: "helper-log-hours",
  helperLogStart: "helper-log-start",
  helperLogEnd: "helper-log-end",
  helperLogSubmit: "helper-log-submit",
  helperRateLeadForm: "helper-rate-lead-form",
  helperRateLeadScore: "helper-rate-lead-score",
  helperRateLeadComment: "helper-rate-lead-comment",
  helperRateLeadSubmit: "helper-rate-lead-submit",
  // Client confirm / contest / billable / rate
  clientBillableSummary: "client-billable-summary",
  clientConfirmCompletion: "client-confirm-completion",
  clientContestCompletion: "client-contest-completion",
  clientContestReason: "client-contest-reason",
  clientRateLeadForm: "client-rate-lead-form",
  clientRateLeadScore: "client-rate-lead-score",
  clientRateLeadComment: "client-rate-lead-comment",
  clientRateLeadSubmit: "client-rate-lead-submit",
  // Admin tabs
  adminRatingsTable: "admin-ratings-table",
  adminRatingsRow: "admin-ratings-row",
  adminTimesheetsTable: "admin-timesheets-table",
  adminTimesheetsRow: "admin-timesheets-row",
  // Marketplace trust badge
  mpRatingBadge: "mp-rating-badge",
  // Trust object surfacing (Lead-side)
  helperTrustBlock: "helper-trust-block",
  // Booking state pill (extended)
  bookingPhase6Pill: "booking-phase6-pill",
  // Dashboard
  dashPendingApprovals: "dash-lead-pending-approvals",
  dashPendingTimesheets: "dash-helper-pending-timesheets",

  // CP-8.3 — Notifications
  notifBell: "notif-bell",
  notifBellBadge: "notif-bell-badge",
  notifDropdown: "notif-dropdown",
  notifDropdownItem: "notif-dropdown-item",
  notifDropdownViewAll: "notif-dropdown-view-all",
  notifInboxRoot: "notif-inbox-root",
  notifInboxRow: "notif-inbox-row",
  notifInboxFilterCategory: "notif-inbox-filter-category",
  notifInboxUnreadOnly: "notif-inbox-unread-only",
  notifMarkRead: "notif-mark-read",
  notifMarkAllRead: "notif-mark-all-read",
  notifStickyBadge: "notif-sticky-badge",
  notifPrefsRoot: "notif-prefs-root",
  notifPrefsRow: "notif-prefs-row",
  notifPrefsEmailToggle: "notif-prefs-email",
  notifPrefsInappToggle: "notif-prefs-inapp",
  notifPrefsDigestToggle: "notif-prefs-digest",
  notifPrefsLockedBadge: "notif-prefs-locked",
  notifPrefsSave: "notif-prefs-save",
  navNotifications: "nav-notifications",

  // CP-8.3 — Admin notification center
  adminNotifTab: "admin-notif-tab",
  adminNotifBoardDispatched: "admin-notif-board-dispatched",
  adminNotifBoardSuppressed: "admin-notif-board-suppressed",
  adminNotifBoardFailed: "admin-notif-board-failed",
  adminNotifCard: "admin-notif-card",
  adminNotifDrilldown: "admin-notif-drilldown",
  adminNotifDrilldownClose: "admin-notif-drilldown-close",
  adminNotifRefresh: "admin-notif-refresh",
  adminNotifRunDispatcher: "admin-notif-run-dispatcher",
  adminNotifRunEmailWorker: "admin-notif-run-email-worker",
  adminNotifRunDigester: "admin-notif-run-digester",
  adminNotifRetryFailed: "admin-notif-retry-failed",
  adminTemplatesTab: "admin-templates-tab",
  adminTemplatesList: "admin-templates-list",
  adminTemplateRow: "admin-template-row",
  adminTemplatePreviewIframe: "admin-template-preview-iframe",

  // CP-11.2 M3 — Escrow (read-only)
  escrowStateBadge: "escrow-state-badge",
  escrowReleaseTimeline: "escrow-release-timeline",
  escrowConditionRow: "escrow-condition-row",
  clientEscrowPanel: "client-escrow-panel",
  leadEscrowPanel: "lead-escrow-panel",
  adminEscrowsTab: "admin-escrows-tab",
  adminEscrowsTable: "admin-escrows-table",
  adminEscrowsRow: "admin-escrows-row",
  adminEscrowsStateFilter: "admin-escrows-state-filter",
  adminEscrowsRefresh: "admin-escrows-refresh",

  // CP-12.4 — Qualifications search + Location/Travel
  mpSearchPage: "marketplace-search-page",
  mpSearchTrackSelect: "marketplace-search-track",
  mpSearchRoleSelect: "marketplace-search-role",
  mpSearchEquipmentSelect: "marketplace-search-equipment",
  mpSearchCertSelect: "marketplace-search-certification",
  mpSearchCountrySelect: "marketplace-search-country",
  mpSearchSubmit: "marketplace-search-submit",
  mpSearchResults: "marketplace-search-results",
  mpSearchEmpty: "marketplace-search-empty",
  mpSearchCard: "marketplace-search-card",
  mpSearchCardName: "marketplace-search-card-name",
  mpSearchCardPrimaryBadge: "marketplace-search-card-primary-track-badge",
  mpSearchCardSecondaryBadge: "marketplace-search-card-secondary-track-badge",
  mpSearchCardVerifyBadge: "marketplace-search-card-verify-badge",
  mpSearchCardRating: "marketplace-search-card-rating",
  qualLocationForm: "qual-location-form",
  qualLocationCountry: "qual-location-country",
  qualLocationRegion: "qual-location-region",
  qualLocationCity: "qual-location-city",
  qualLocationSave: "qual-location-save",
  qualTravelForm: "qual-travel-form",
  qualTravelRadius: "qual-travel-radius",
  qualTravelWorkAuth: "qual-travel-work-auth",
  qualTravelPassport: "qual-travel-passport",
  qualTravelSave: "qual-travel-save",

  // CP-12.5 — Verifications
  verifClientForm: "verif-client-form",
  verifClientSubmit: "verif-client-submit",
  verifClientKindSelect: "verif-client-kind",
  verifClientSubjectSelect: "verif-client-subject",
  verifClientTierSelect: "verif-client-tier",
  adminVerifTab: "admin-verif-tab",
  adminVerifTable: "admin-verif-table",
  adminVerifRow: "admin-verif-row",
  adminVerifRequestsTab: "admin-verif-requests-tab",
  adminVerifRequestRow: "admin-verif-request-row",
  adminVerifGrantBtn: "admin-verif-grant-btn",
  adminVerifGrantForm: "admin-verif-grant-form",
  adminVerifRevokeBtn: "admin-verif-revoke-btn",
  myVerifBadgesPanel: "my-verif-badges-panel",
  myVerifRequestBtn: "my-verif-request-btn",
  myVerifRow: "my-verif-row",

  // CP-14.6.3 — RFQ Sourcing Funnel
  cssResultSendRfq: "css-result-send-rfq",
  rfqModal: "rfq-modal",
  rfqModalNotes: "rfq-modal-notes",
  rfqModalExpiry: "rfq-modal-expiry",
  rfqModalSubmit: "rfq-modal-submit",
  rfqModalCancel: "rfq-modal-cancel",
  rfqModalCrewRow: "rfq-modal-crew-row",
  rfqModalError: "rfq-modal-error",
  navRfq: "nav-rfq",
  rfqInboxRoot: "rfq-inbox-root",
  rfqInboxTabSent: "rfq-inbox-tab-sent",
  rfqInboxTabInbox: "rfq-inbox-tab-inbox",
  rfqInboxRow: "rfq-inbox-row",
  rfqInboxEmpty: "rfq-inbox-empty",
  rfqDetailRoot: "rfq-detail-root",
  rfqDetailStatus: "rfq-detail-status",
  rfqDetailExpiry: "rfq-detail-expiry",
  rfqDetailSender: "rfq-detail-sender",
  rfqDetailRecipient: "rfq-detail-recipient",
  rfqDetailSnapshot: "rfq-detail-snapshot",
  rfqDetailSnapshotRow: "rfq-detail-snapshot-row",
  rfqDetailAcceptBtn: "rfq-detail-accept-btn",
  rfqDetailDeclineBtn: "rfq-detail-decline-btn",
  rfqDetailWithdrawBtn: "rfq-detail-withdraw-btn",
  rfqDetailThread: "rfq-detail-thread",
  rfqDetailThreadMessage: "rfq-detail-thread-message",
  rfqDetailComposer: "rfq-detail-composer",
  rfqDetailComposerInput: "rfq-detail-composer-input",
  rfqDetailComposerSend: "rfq-detail-composer-send",
  rfqDetailComposerClosed: "rfq-detail-composer-closed",
  rfqDetailAuditToggle: "rfq-detail-audit-toggle",
  rfqDetailAuditDrawer: "rfq-detail-audit-drawer",
  rfqDetailAuditRow: "rfq-detail-audit-row",
};
